export default __webpack_public_path__ + "static/media/plus.5b248bc9.svg";